<template>
  <div class="adviceBox">
    <div class="display_flex top">
      <!-- 顶部左侧 -->
      <div class="tabSet">
        <div :class="activeName==1?'active':''" @click="handleChange(1)">药品目录</div>
        <div :class="activeName==2?'active':''" @click="handleChange(2)">耗材目录</div>
        <div :class="activeName==3?'active':''" @click="handleChange(3)">治疗项目录</div>
      </div>
      <!-- 顶部右侧 -->
    </div>
    <div class="addform">
      <el-form :inline="true" :rules="rulesform" :model="ruleForm" ref="ruleForms" class="demo-form-inline w-144">
        <div class="title">基本信息</div>
        <el-row style="width: 100%;">
          <el-col :span="8">
            <el-form-item label="收费种类" prop="dict_type">
              <el-select v-model="ruleForm.dict_type">
                <el-option v-for="item in dictList[160000000]" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="助记码 ">
              <el-input v-model="ruleForm.ma" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="药品名称 " v-if="activeName == '1'" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="耗材名称 " v-if="activeName == '2'" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="治疗名称 " v-if="activeName == '3'" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入" />
              <!-- <el-input v-model="ruleForm.name" placeholder="请输入" :disabled="disabled" /> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="width: 100%;">
          <el-col :span="8">
            <el-form-item label="医保编码 ">
              <el-input v-model="ruleForm.code" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="activeName == '1' || activeName == '2'">
            <el-form-item label="国药准字 ">
              <el-input v-model="ruleForm.approval_no" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="activeName == '1'">
            <el-form-item label="打印类型">
              <el-select v-model="ruleForm.dict_type">
                <el-option v-for="item in dictList[909100000]" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="activeName == '2'">
            <el-form-item label="自动出库" prop="auto_out">
              <!-- <el-select v-model="ruleForm.auto_out">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select> -->
              <el-switch v-model="ruleForm.auto_out" />
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="activeName == '3'" >
            <el-form-item label="单位">
              <el-select v-model="ruleForm.min_package_unit" prop="min_package_unit" @change="min_package_unitChange">
                <el-option v-for="item in dictList[176000000]" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="activeName == '3'">
            <el-form-item label="零售价">
              <el-input v-model="ruleForm.sell_price">
                <template #append>元/{{ruleForm.min_package_unit_name}}</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="activeName == '1'">
          <el-col :span="16">
            <el-form-item label="生产厂家" prop="company" style="width: 100% !important">
              <el-input v-model="ruleForm.company" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="自动出库" prop="auto_out">
              <!-- <el-select v-model="ruleForm.auto_out">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select> -->
              <el-switch v-model="ruleForm.auto_out" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="width: 100%;" v-if="activeName == '2'">
          <el-col :span="24">
            <el-form-item label="生产厂家" prop="company" style="width: 80% !important">
              <el-input style="width: 80% !important" v-model="ruleForm.company" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="width: 100%;" v-if="activeName == '2'||activeName == '3'">
          <el-col :span="24">
            <el-form-item label="备注" style="width: 80% !important">
              <el-input style="width: 80% !important" v-model="ruleForm.remark" :autosize="{ minRows: 2, maxRows: 4 }"
                type="textarea" placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="title" v-if="activeName == '1'||activeName == '2'">规格信息</div>
        <div style="width: 100%;" v-if="activeName == '1'||activeName == '2'">
          <el-row style="width: 480px;margin-left: 44px;">
            <el-col :span="8">
              <div class="infoTitle"><span class="importantX">*</span> {{activeName=='1'?'制剂数量':'包装数量'}}</div>
              <div>
                <el-form-item label="" v-if="activeName != '3'" prop="min_package_num">
                  <el-input v-model="ruleForm.min_package_num" clearable />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="infoTitle"><span class="importantX">*</span>{{activeName=='1'?'制剂单位':'小单位'}}</div>
              <div>
                <el-form-item label="" v-if="activeName != '3'" prop="min_unit">
                  <el-select v-model="ruleForm.min_unit" @change="min_unitChange">
                    <el-option v-for="item in dictList[176000000]" :key="item.id" :label="item.name"
                      :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="1">
              <div style="color: #fff;">/</div>
              <div style="font-size: 23px; margin-top: 10px;">/</div>
            </el-col>
            <el-col :span="7">
              <div class="infoTitle"><span class="importantX">*</span>包装单位</div>
              <div>
                <el-form-item label="" prop="min_package_unit" v-if="activeName != '3'">
                  <el-select v-model="ruleForm.min_package_unit" @change="min_packageChange">
                    <el-option v-for="item in dictList[176000000]" :key="item.id" :label="item.name"
                      :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row style="width: 480px;margin-left: 44px;" v-if="activeName == '1'">
            <el-col :span="3">
              <div class="infoTitle">用量规格</div>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <el-input v-model="ruleForm.dosage">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="">
                <el-select v-model="ruleForm.dict_base_unit" @change="dict_base_unitChange">
                  <el-option v-for="item in dictList[157000000]" :key="item.id" :label="item.name"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div style="font-size: 23px;">/</div>
            </el-col>
            <el-col :span="7">
              <el-form-item label="" prop="min_unit">
                <el-select v-model="ruleForm.min_unit" disabled>
                  <el-option v-for="item in dictList[176000000]" :key="item.id" :label="item.name"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <br>
          <el-row style="width: 480px;margin-left: 44px;">
            <el-col :span="3">
              <div class="infoTitle"><span class="importantX">*</span>规格</div>
            </el-col>
            <el-col :span="21">
              <div class="infoTitleInput" @click="setMeduic" v-if="!medi_specSet">
                <span
                  v-if="activeName==1">{{ruleForm.min_package_num}}{{ruleForm.min_unit_name}}/{{ruleForm.min_package_unit_name}},
                  {{ruleForm.dosage}}{{ruleForm.dict_base_unit_name}}/{{ruleForm.min_unit_name}}</span>
                <span
                  v-if="activeName==2">{{ruleForm.min_package_num}}{{ruleForm.min_unit_name}}/{{ruleForm.min_package_unit_name}}
                </span>
              </div>
              <el-form-item v-if="medi_specSet" style="width: 93%;" label="" prop="medi_spec">
                <el-input v-model="ruleForm.medi_spec" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row style="width: 480px;margin-left: 44px;">
            <el-col :span="3">
              <div class="infoTitle">库存预警</div>
            </el-col>
            <el-col :span="9">
              <el-form-item label="" v-if="activeName != '3'">
                <el-input v-model="ruleForm.is_early_warning">
                  <template #append>件</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <div class="infoTitle">零售价</div>
            </el-col>
            <el-col :span="9">
              <el-form-item label="" v-if="activeName != '3'">
                <el-input v-model="ruleForm.sell_price">
                  <template #append>元/{{ruleForm.min_unit_name}}</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="width: 480px;margin-left: 44px;" v-if="activeName != '3'">
            <el-col :span="4">
              <div class="infoTitle"><span class="importantX">*</span>销售单位</div>
            </el-col>
            <el-col :span="20">
              <el-form-item label=""  prop="dict_first_unit">
                <el-select v-model="ruleForm.dict_first_unit">
                  <el-option v-for="item in unitSlected" :key="item.id" :label="item.name"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="title" v-if="activeName == '1'">用法</div>
        <el-row v-if="activeName == '1'">
          <el-col :span="8">
            <el-form-item label="用药途径">
              <el-select v-model="ruleForm.dict_use_way">
                <el-option v-for="item in dictList[158000000]" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用药频次">
              <el-select v-model="ruleForm.dict_frequency">
                <el-option v-for="item in dictList[159000000]" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单次剂量">
              <el-input v-model="ruleForm.dosage">
                <template #append>{{ruleForm.dict_base_unit_name}}</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="width: 100%;" v-if="activeName == '1'">
          <el-col :span="24">
            <el-form-item label="备注" style="width: 80% !important">
              <el-input style="width: 80% !important" v-model="ruleForm.remark" :autosize="{ minRows: 2, maxRows: 4 }"
                type="textarea" placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="耗材类别:" v-if="activeName == '2'">
          <el-select v-model="ruleForm.dict_material_type">
            <el-option v-for="item in dictList[164000000]" :key="item.id" :label="item.name"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item label="治疗类别:" v-if="activeName == '3'">
          <el-select v-model="ruleForm.dict_service_type">
            <el-option v-for="item in dictList[161000000]" :key="item.id" :label="item.name"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item> -->


        <!-- <el-form-item label="进价：" v-if="activeName != '3'">
          <el-input v-model="ruleForm.buy_price">
            <template #append>元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="销售单位：" v-if="activeName != '3'" prop="dict_first_unit">
          <el-select v-model="ruleForm.dict_first_unit">
            <el-option v-for="item in dictList[176000000]" :key="item.id" :label="item.name"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="是否启用：">
          <el-switch v-model="ruleForm.is_enable" inline-prompt active-text="是" inactive-text="否" />
        </el-form-item> -->
        <div v-if="activeName==3" class="pin"></div>
      </el-form>
    </div>
    <el-divider />
    <div style="text-align: right">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="Confirmpuncture">确定</el-button>
    </div>
  </div>
</template>

<script>
  import { toRefs, reactive, onMounted, ref, getCurrentInstance } from 'vue'
  import service from '@/utils/request'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToTime } from '@/utils/tool'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { ElMessage } from 'element-plus'
  export default {
    components: {
      BaseDialog,
    },
    setup() {
      let { proxy } = getCurrentInstance()
      const state = reactive({
        ruleForm: {
          tag: [],
          is_enable: true,
        },
        tags: [],
        formData: {
          status: '',
        },
        unitSlected:[],
        dictList: {},
        tableData: [],
        listop: [],
        lists: [],
        doclist: [],
        doclists: [],
        puncture: false,
        saveLoading: false,
        rulesform: {
          name:[{required:true,trigger:'blur',message:'请输入'}],
          company: [{ required: true, trigger: 'blur', message: '请输入' },],
          dict_type: [{ required: true, trigger: 'change', message: '请选择' },],
          medi_spec: [{ required: true, trigger: 'blur', message: '请输入' },],
          min_package_unit: [{ required: true, trigger: 'change', message: '请选择' },],
          min_unit: [{ required: true, trigger: 'change', message: '请选择' },],
          dict_first_unit: [{ required: true, trigger: 'change', message: '请选择' },],
          min_package_num: [{ required: true, trigger: 'blur', message: '请输入' },]
        },
        isRecord: false,
        dict_type: '',
        activeName: '1',
        tableHei: '',
        disabled: false,
        dict_advice_type: '',
        dict_catalog_type: '',
        medi_specSet: false,
        conmons: [],
        title: ''
      })
      onMounted(() => {
        state.ruleForm.auto_out = true
        initData()
      })
      const handleChange = (code) => {
        state.activeName = code
        initData()
        if (state.activeName == 1 || state.activeName == '2') {
          state.ruleForm.auto_out = true
        }
        
      }
      const min_package_unitChange = (e)=>{
        state.ruleForm.min_package_unit = e
        state.dictList[176000000].forEach(item => {
          if (item.code == e) {
            state.ruleForm.min_package_unit_name = item.name
          }
        })
      }
      const min_unitChange = (e) => {
        state.ruleForm.min_unit = e
        state.dictList[176000000].forEach(item => {
          if (item.code == e) {
            state.ruleForm.min_unit_name = item.name
          }
        })
        var index = state.unitSlected.findIndex(item=>item.code===e)
        console.log(index)
        if(index==-1){
          state.unitSlected.push({
            code:e,
            name:state.ruleForm.min_unit_name
          })
        }
      }
      const min_packageChange = (e) => {
        // state.unitSlected
        state.ruleForm.min_package_unit = e
        state.dictList[176000000].forEach(item => {
          if (item.code == e) {
            state.ruleForm.min_package_unit_name = item.name
          }
          
        })
        var index = state.unitSlected.findIndex(item=>item.code===e)
        console.log(index)
        if(index==-1){
          state.unitSlected.push({
            code:e,
            name:state.ruleForm.min_package_unit_name
          })
        }
      }
      const dict_base_unitChange = (e) => {
        state.ruleForm.dict_base_unit = e
        state.dictList[157000000].forEach(item => {
          if (item.code == e) {
            state.ruleForm.dict_base_unit_name = item.name
          }
        })
        var index = state.unitSlected.findIndex(item=>item.code===e)
        if(index==-1){
          state.unitSlected.push({
            code:e,
            name:state.ruleForm.min_package_unit_name
          })
        }
      }
      const setMeduic = () => {
        state.medi_specSet = true
        let num = state.ruleForm.min_package_num == undefined ? 0 : state.ruleForm.min_package_num
        // if (state.activeName == 1) {
        //   let dosage = state.ruleForm.dosage == undefined ? 0 : state.ruleForm.dosage
        //   state.ruleForm.medi_spec = num + state.ruleForm.min_unit_name + '/' + state.ruleForm.min_package_unit_name + ',' +
        //     dosage + state.ruleForm.dict_base_unit_name + '/' + state.ruleForm.min_unit_name
        // } else {
        //   state.ruleForm.medi_spec = num + state.ruleForm.min_unit_name + '/' + state.ruleForm.min_package_unit_name
        // }

      }
      // 获取字典
      const initData = async () => {
        state.dictList = await gitDictList([
          '332900000',
          '210000000',
          '103000000',
          '160000000',
          '116000000',
          '176000000',
          '231000000',
          '157000000',
          '158000000',
          '159000000',
          '339600000',
          '164000000',
          '113000000',
          '161000000',
          '100000000',
          '340200000',
          '339600000',
          '176000000',
          '909100000'
        ])
        state.ruleForm.min_unit = state.dictList[176000000][0].code
        state.ruleForm.dict_base_unit = state.dictList[157000000][0].code
        state.ruleForm.min_package_unit = state.dictList[176000000][0].code
        state.ruleForm.min_unit_name = state.dictList[176000000][0].name
        state.ruleForm.dict_base_unit_name = state.dictList[157000000][0].name
        state.ruleForm.min_package_unit_name = state.dictList[176000000][0].name
        state.dictList[332900000].forEach((item) => {
          item.active = false
        })
        state.listop = state.dictList[332900000]
        state.lists = JSON.parse(JSON.stringify(state.dictList[332900000]))
        // 治疗项
        state.dictList[340200000].forEach((item) => {
          item.active = false
        })
        state.unitSlected = [
          {
            name:state.dictList[176000000][0].name,
            code:state.dictList[176000000][0].code
          }
        ]
        state.ruleForm.dict_first_unit = state.dictList[176000000][0].code
        state.doclist = state.dictList[340200000]
        state.doclists = JSON.parse(JSON.stringify(state.dictList[340200000]))
      }
      // 弹窗取消
      const cancel = () => {
        state.ruleForm = {}
        setTimeout(() => {
          proxy.$refs.ruleForms.clearValidate()
        }, 50)
      }
      // 新增确定
      const Confirmpuncture = async () => {
        proxy.$refs.ruleForms.validate(async (voild) => {
          if (voild) {
            if (state.activeName == '1') {
              state.ruleForm.dict_advice_type = '163110000'
              state.ruleForm.type = '160000000'
            } else if (state.activeName == '2') {
              state.ruleForm.type = '164000000'
              state.ruleForm.dict_advice_type = '163120000'
            } else {
              state.ruleForm.dict_advice_type = '163120000'
              state.ruleForm.type = '161000000'
            }
            let data = {
              ...state.ruleForm,
              auto_out: state.ruleForm.auto_out == true ? 1 : 0
            }
            console.log(data)
            if (!state.ruleForm.id) {
              let res = await service.post('/api/drug/create', data)
              if (res.code == 0) {
                ElMessage({
                  message: '保存成功',
                  type: 'success',
                })
                state.disabled = false
                state.ruleForm = {}
                setTimeout(() => {
                  proxy.$refs.ruleForms.clearValidate()
                }, 50)
              }
            } else {
              let res = await service.post('/api/drug/edit', state.ruleForm)
              if (res.code == 0) {
                ElMessage({
                  message: '修改成功',
                  type: 'success',
                })
                state.disabled = false
                state.ruleForm = {}
              }
            }
          } else {
            return false
          }
        })

      }

      return {
        ...toRefs(state),
        initData,
        handleChange,
        Confirmpuncture,
        cancel,
        min_unitChange,
        min_packageChange,
        dict_base_unitChange,
        setMeduic,
        min_package_unitChange
      }
    },
  }
</script>

<style scoped lang="scss">
  .importantX{
    color: red;
    margin-right: 4px;
  }
  .content {
    background-color: #fff;
  }
  .pin{
    width: 100%;
    height: 180px;
  }
  .infoTitleInput {
    height: 32px;
    line-height: 32px;
    width: 80%;
    border: 1px solid #dcdfe6;
    padding-left: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .title {
    width: 100%;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 5px;
  }

  .infoTitle {
    padding: 5px 0;
  }

  .tabSet {
    height: 40px;
    width: 100%;
    line-height: 40px;
    display: flex;
    justify-content: start;
    align-items: center;
    border-bottom: 2px solid #e4e7ed;

    div {
      margin-right: 20px;
      color: #333;
      border-bottom: none;
    }

    .active {
      color: #3166ae;
      border-bottom: 2px solid #3166ae;
    }
  }

  .el-link {
    margin-right: 8px;
  }

  .adviceBox {
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding: 10px;
  }

  .demo-tabs>.el-tabs__content {
    padding: 32px;
    color: #6b778c;
    font-size: 32px;
    font-weight: 600;
  }

  .display_flex {
    display: flex;
    justify-content: space-between;
  }

  .search-top .w-208 {
    width: 208px;

    .searchcss {
      cursor: pointer;
    }
  }

  .faicon {
    font-size: 19px;
    margin-right: 6px;
    cursor: pointer;
  }

  .tabclis {
    height: 32px;
    background: rgba(49, 102, 174, 0.1);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    display: flex;
    padding: 3px;

    .tabclis_right {
      display: flex;
      padding-top: 2px;
    }
  }

  .addform {
    .el-form {
      display: flex;
      flex-wrap: wrap;

      &:deep(.el-form-item__label) {
        width: 130px !important;
        text-align: right;
      }

      &:deep(.el-input) {
        // width: 200px !important;
        width: 100%;
      }

      /* &:deep(.el-form-item) {
        width: 30% !important;
      } */

      .mt_4 {
        &:deep(.el-input) {
          width: 100px !important;
        }
      }

      .parienttag {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .tag {
          margin-right: 8px;
          margin-bottom: 8px;
          color: #409eff;
          background-color: #ecf5ff;
          height: 20px;
          line-height: 20px;
          border-radius: 3px;
          text-align: center;
          font-size: 12px;
          padding: 0 10px;
          cursor: pointer;
        }

        .tags {
          margin-right: 8px;
          margin-bottom: 8px;
          background: #409eff;
          color: #ffffff;
          border-radius: 3px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          font-size: 12px;
          padding: 0 10px;
          cursor: pointer;
        }
      }
    }
  }

  .pagination-box {
    &:deep(.el-input__inner) {
      padding-right: 15px !important;
    }
  }

  .w-144 {
    margin-top: 20px;
  }

  .stop {
    background-color: #f4a939;
  }

  .modify {
    background-color: #3166ae;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .top {
    height: 35px;
    margin: 8px 0;
  }
</style>

<style scoped>
  .el-input-group__append .el-select>>>.el-input__inner {
    border: none !important;
  }

  .el-form.w-144 .el-select {
    width: 100%;
  }
</style>
<style>
  .el-table .warning-row {
    background: #fff3e0;
  }

  .el-table .danger-row {
    background: #ffebee;
  }
</style>